import { object, string, number } from 'yup';

import { LOCATION_TYPE } from 'enum/location';

export const validationSchema = object().shape({
  name: string()
    .trim()
    .max(250, 'Name cannot be more than 250 characters.')
    .min(3, 'Name cannot be less than 3 characters.')
    .required('Name is required'),
  category: string().required('Category is required'),
  assetValue: number()
    .required('Operational Importance is required')
    .min(1, 'Operational Importance must be at least 1')
    .max(10, 'Operational Importance can be at most 10'),
  profileGroup: string().required('Profile Group is required'),
  description: string().optional().max(255, 'Description cannot be more than 255 characters'),
  location: string().oneOf(Object.values(LOCATION_TYPE)).required('Location type is required'),
  lat: number().when('location', {
    is: LOCATION_TYPE.COORDINATES,
    then: (schema) => schema.required('Latitude is required'),
    otherwise: (schema) => schema.optional(),
  }),
  lng: number().when('location', {
    is: LOCATION_TYPE.COORDINATES,
    then: (schema) => schema.required('Longitude is required'),
    otherwise: (schema) => schema.optional(),
  }),
});
